import AuthLayout from "./AuthLayout";
import { useNavigate } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { showError, showToast } from "../../constants/toasts";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useForgotPasswordMutation } from "../../service/auth";
import { isValidInput } from "../../utils/validations";
import { OTP_FOR } from "../../constants/enums";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [forgotPasswordApi, { isLoading }] = useForgotPasswordMutation();

  const formik = useFormik({
    initialValues: {
      email: "",
    },

    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required!")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address!"
        ),
    }),

    onSubmit: async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);

        const body = { email: values.email, otpType: OTP_FOR.FORGOT_PASSWORD };
        console.log("forgot_password_body:", body);

        const response: any = await forgotPasswordApi(body).unwrap();

        if (response?.code === 200 || response?.statusCode === 200) {
          showToast(response?.message || "OTP sent successfully");

          // Passing email to OTP page
          navigate("/otp", { state: { email: values.email } });
        }
      } catch (error: any) {
        console.error(error);
        showError(error?.data?.message || "Something went wrong");
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Forgot Password</h2>
        <p
          style={{
            marginBottom: 15,
          }}
        >
          Please provide your email address to reset your password
        </p>

        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="control_group">
            <label htmlFor="email">Email Address</label>
            <TextField
              id="email"
              name="email"
              type="email"
              placeholder="Enter Email Address"
              fullWidth
              value={formik.values.email}
              onChange={(e) => {
                const val = e.target.value;
                console.log(val, "valval");
                if (val.includes(" ") || val.includes(" ")) return;
                formik.handleChange(e);
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
          </div>

          <div className="form_btn">
            <Button
              type="submit"
              className="btn btn_primary w_100"
              // onClick={() => navigate("/otp")}
            >
              Submit
            </Button>
          </div>
        </form>

        <div className="auth_bottom">
          <p>
            <button
              type="button"
              className="link"
              onClick={() => navigate("/")}
            >
              <KeyboardBackspaceIcon /> Back to Login
            </button>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
